export const LOGIN_OVERVIEW_BUTTONS_TEST_ID = "login-overview-buttons";
export const LOGIN_OVERVIEW_EMAIL_BUTTON_TEST_ID = "login-overview-email-button";
export const LOGIN_OVERVIEW_REGISTER_LINK_TEST_ID = "login-overview-register-link";
